import { observable, computed, action, decorate, runInAction, toJS } from 'mobx';
import Http from './Http';
import { PromiseHelper, Counter } from './_StoreHelper';

const promiseCache = new PromiseHelper();

const toDate = (s) => s ? new Date(s) : s;

const datifyProperty = (item, key) => {
    if (item.hasOwnProperty(key)) {
        item[key] = toDate(item[key])
    }
}

export function processDates(data) {
    if (data) {
        function process(datum) {
            if (datum) {
                datifyProperty(datum, 'issueDate');
                datifyProperty(datum, 'expireDate');
                datifyProperty(datum, 'createdTime');
                datifyProperty(datum, 'updatedTime');
            }
        }
        if (Array.isArray(data)) {
            data.forEach((datum) => {
                process(datum);
            });
        } else {
            process(data);
        }
    }
    return data;
}

function processData(data) {
    /*if (data) {
        function process(datum) {
            //datum.name = `${datum.firstName} ${datum.lastName}`.trim();
        }
        if (Array.isArray(data)) {
            data.forEach((datum) => {
                process(datum);
            });
        } else {
            process(data);
        }
    }*/
    return data;
}

function processItems(data) {
    if (data) {
        function process(datum) {
            //datum.name = `${datum.firstName} ${datum.lastName}`.trim();
            if (datum.fileHistory) {
                const counter = new Counter();
                datum.fileHistory.sort((a, b) => b.dateCreated - a.dateCreated);
                datum.fileHistory.forEach((fh) => {
                    counter.incrementByOne(fh.formName);
                });
                datum.fileHistory.forEach((fh) => {
                    fh.version = counter.getCount(fh.formName);
                    counter.decrementByOne(fh.formName);
                });
            }
            if (datum.fileAttachments) {
                datum.fileAttachments.forEach(fa => {

                    const formType = fa.formType;
                    const fileName = fa.fileName;
                    const fileExt = fileName.split('.').pop();

                    fa.fileName = `${formType}.${fileExt}`
                })
            }
        }
        if (Array.isArray(data)) {
            data.forEach((datum) => {
                process(datum);
            });
        } else {
            process(data);
        }
    }
    return data;
}

class ItemsStore {
    items = {};
    itemTypes = {};

    constructor() { }

    get sizeItems() {
        return Object.keys(this.items).length;
    }
    get sizeItemTypes() {
        return Object.keys(this.itemTypes).length;
    }

    get valuesItems() {
        return Object.values(this.items);
    }

    get valuesItemTypes() {
        return Object.values(this.itemTypes);
    }

    _updateStats() {
        const itemsByType = {};
        Object.values(this.items).forEach((item) => {
            const id = item.itemTypeId;
            if (!itemsByType[id]) {
                itemsByType[id] = [];
            }
            itemsByType[id].push(item);
        });
        const values = Object.values(this.itemTypes);
        values.forEach((itemType) => {
            const items = itemsByType[itemType.id] || [];
            itemType.stats = {
                items: items.length,
                contracts: new Set(items.map((item) => item.contractId).filter(c => !!c)).size,
                people: new Set(items.map((item) => item.userId).filter(c => !!c)).size,
            };
            //itemType.items = items;
        });
    }

    fetchAllItems(includeFileHistory = false) {
        const KEY = 'fetchAllItems';
        if (promiseCache.getPromise(KEY)) {
            return promiseCache.getPromise(KEY);
        }
        const promise = Http.get('/items', {
            params: {
                includeFileHistory: includeFileHistory,
            },
        })
            .then((response) => {
                promiseCache.removePromise(KEY);
                const data = processItems(processDates(response.data));
                const map = {};
                data.forEach((datum) => {
                    map[datum.id] = datum;
                });
                runInAction(() => {
                    this.items = map;
                    this._updateStats();
                });
                return data;
            })
            .catch((err) => {
                promiseCache.removePromise(KEY);
                throw err;
            });
        promiseCache.putPromise(KEY, promise);
        return promise;
    }

    fetchAllItemsForPerson(peopleId) {
        return this.fetchAllItems()
            .then((data) => {
                const people = Object.values(data);
                return people.filter((person) => person.id === peopleId);
            })
            .catch((err) => {
                throw err;
            });
    }

    fetchAllItemTypes() {
        const KEY = 'fetchAllItemTypes';
        if (promiseCache.getPromise(KEY)) {
            return promiseCache.getPromise(KEY);
        }
        const promise = Http.get('/items/types')
            .then((response) => {
                promiseCache.removePromise(KEY);
                const data = processData(processDates(response.data));
                const map = {};
                data.forEach((datum) => {
                    map[datum.id] = datum;
                });
                runInAction(() => {
                    this.itemTypes = map;
                    this._updateStats();
                });
                return data;
            })
            .catch((err) => {
                promiseCache.removePromise(KEY);
                throw err;
            });
        promiseCache.putPromise(KEY, promise);
        return promise;
    }

    fetchItem(itemId) {
        const KEY = `fetchItem_${itemId}`;
        if (promiseCache.getPromise(KEY)) {
            return promiseCache.getPromise(KEY);
        }
        const promise = Http.get(`/items?itemId=${itemId}`)
            .then((response) => {
                promiseCache.removePromise(KEY);
                const dataItems = processItems(processDates(response.data));
                if (!dataItems || dataItems.length == 0) {
                    throw new Error("Item not found");
                }
                const data = dataItems[0];
                runInAction(() => {
                    this.items[data.id] = data;
                    this._updateStats();
                });
                return data;
            })
            .catch((err) => {
                promiseCache.removePromise(KEY);
                throw err;
            });
        promiseCache.putPromise(KEY, promise);
        return promise;
    }

    fetchItemType(itemTypeId) {
        return new Promise((resolve, reject) => {
            this.fetchAllItemTypes().then(data => {
                for (let i = 0; i < data.length; i++) {
                    let datum = data[i];
                    if (datum.id == itemTypeId) {
                        resolve(datum);
                        return;
                    }
                }
                reject("Item not found")
            }).catch(err => reject(err))
        });
    }

    createItem(itemDetails) {
        return Http.post('/items', itemDetails).then((response) => {
            const data = processItems(processDates(response.data));
            runInAction(() => {
                this.items[data.id] = data;
                this._updateStats();
            });
            return data;
        });
    }

    createItemTypes(itemTypeDetails) {
        return Http.post('/items/types', itemTypeDetails).then((response) => {
            const data = processData(processDates(response.data));
            runInAction(() => {
                this.itemTypes[data.id] = data;
                this._updateStats();
            });
            return data;
        });
    }

    updateItem(itemDetails) {
        return Http.put('/items', itemDetails).then((response) => {
            const data = processItems(processDates(response.data));
            runInAction(() => {
                this.items[data.id] = data;
                this._updateStats();
            });
            return data;
        });
    }

    updateItemType(itemTypeDetails) {
        return Http.put('/items/types', itemTypeDetails).then((response) => {
            const data = processData(processDates(response.data));
            runInAction(() => {
                this.itemTypes[data.id] = data;
                this._updateStats();
            });
            return data;
        });
    }

    uploadForm(itemId, formName, file, onUploadProgress) {
        const data = new FormData();
        data.append('file', file);
        data.append('uploadFileType', 'ITEM');
        data.append('itemId', itemId);
        data.append('formName', formName);
        return Http.post('/items/upload', data, {
            onUploadProgress: (progressEvent) => {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                console.log(`itemId=${itemId} | formName=${formName} | uploadProgess=${progress}%`);
                onUploadProgress && onUploadProgress(progressEvent);
            },
        }).then((res) => {
            return processDates(res.data);
        });
    }

    uploadFileContract(contractId, formName, file, onUploadProgress) {
        const data = new FormData();
        data.append('file', file);
        data.append('uploadFileType', 'CONTRACT');
        data.append('contractId', contractId);
        data.append('formName', formName);
        return Http.post('/api/items/form-upload', data, {
            onUploadProgress: (progressEvent) => {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                console.log(`contractId=${contractId} | formName=${formName} | uploadProgess=${progress}%`);
                onUploadProgress && onUploadProgress(progressEvent);
            },
        }).then((res) => {
            return processDates(res.data);
        });
    }

    uploadFileCustomer(customerId, formName, file, onUploadProgress) {
        const data = new FormData();
        data.append('file', file);
        data.append('uploadFileType', 'CUSTOMER');
        data.append('customerId', customerId);
        data.append('formName', formName);
        return Http.post('/api/items/form-upload', data, {
            onUploadProgress: (progressEvent) => {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                console.log(`customerId=${customerId} | formName=${formName} | uploadProgess=${progress}%`);
                onUploadProgress && onUploadProgress(progressEvent);
            },
        }).then((res) => {
            return processDates(res.data);
        });
    }

    uploadFilePrimeContractor(primeContractorId, formName, file, onUploadProgress) {
        const data = new FormData();
        data.append('file', file);
        data.append('uploadFileType', 'PRIME_CONTRACTOR');
        data.append('primeContractorId', primeContractorId);
        data.append('formName', formName);
        return Http.post('/api/items/form-upload', data, {
            onUploadProgress: (progressEvent) => {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                console.log(
                    `primeContractorId=${primeContractorId} | formName=${formName} | uploadProgess=${progress}%`
                );
                onUploadProgress && onUploadProgress(progressEvent);
            },
        }).then((res) => {
            return processDates(res.data);
        });
    }

    deleteItem(itemId) {
        return Http.delete(`/api/items/${itemId}`)
            .then((response) => {
                runInAction(() => {
                    delete this.items[itemId];
                    this._updateStats();
                });
                return processDates(response.data);
            })
            .catch((err) => {
                throw new Error(err.response.data.error);
            });
    }

    deleteItemType(itemTypeId) {
        return Http.delete(`/api/item-types/${itemTypeId}`)
            .then((response) => {
                runInAction(() => {
                    delete this.itemTypes[itemTypeId];
                    this._updateStats();
                });
                return processDates(response.data);
            })
            .catch((err) => {
                throw new Error(err.response.data.error);
            });
    }

    toJSItems() {
        return toJS(this.items);
    }

    toJSItemTypes() {
        return toJS(this.itemTypes);
    }
}

decorate(ItemsStore, {
    items: observable,
    itemTypes: observable,
    sizeItems: computed,
    sizeItemTypes: computed,
    valuesItems: computed,
    valuesItemTypes: computed,
});

const storeInstance = new ItemsStore();

export default storeInstance;
